const apiUrl = process.env.REACT_APP_API_BASE_URL;

module.exports = {
    //Login
    AUTHENTICATE_USER: `${apiUrl}/api/User/email`,
    USER_ROLE: `${apiUrl}/api/User/id`,

    //Change Password
    CHANGE_PASSWORD: `${apiUrl}/api/User/password`,

    //Lookup
    LOOKUP_DATA: `${apiUrl}/api/LookUp`,
    ACTION_YARDLOOKUP: `${apiUrl}/api/yard`,
    ACTION_COMMONROLES: `${apiUrl}/api/Master/CommonRoles`,
    ACTION_COMMONTRAININGS: `${apiUrl}/api/Master/CommonTrainings`,
    VERIFY_LOOKUPYARD: `${apiUrl}/api/Yard/verify`,

    //User Management 
    USER_DATA: `${apiUrl}/api/User/User/`,
    USER_MANAGEMENT: `${apiUrl}/api/User/Users`,
    ADDUSER_MANAGEMENT: `${apiUrl}/api/User/ProcessUsers`,
    CHANGE_USERSTATUS: `${apiUrl}/api/User/ChangesUserStaus`,

    //HistoryLog
    HISTORY_LOG: `${apiUrl}/api/Log/`,

    //Project Management
    GET_PROJECT: `${apiUrl}/Project`,
    DELETE_PROJECT: `${apiUrl}/Project/project/`,
    ASSIGN_USER: `${apiUrl}/Project/AssginUsers`,

    // Add New Project 
    ADDEDIT_PROJECT: `${apiUrl}/Project/`,
    ADDEDITINCHARGE_PROJECT: `${apiUrl}/Project/AssginUsers`,
    ADDSHIPINFO_PROJECT: `${apiUrl}/api/ShipParticular`,
    ADDPROCESSINFO_PROJECT: `${apiUrl}/api/ProjectProcess`,
    SETTINGS_PROJECT: `${apiUrl}/api/ProjectSetting/`,
    SETTINGS_PROJECT_POST: `${apiUrl}/api/ProjectSetting`,
    ADDEDIT_SHIPINFO: `${apiUrl}/api/ShipParticular/`,

    // Documents 
    GET_DOCUMENTSNAME: `${apiUrl}/api/LookUp/GetProjectLookups`,
    GET_DOCUMENTSLIST: `${apiUrl}/api/Documents`,

    // Edit Project 
    // EDITBASICINFO_PROJECT: `${apiUrl}/Project/`,
    // EDITPROCESSINFO_PROJECT: `${apiUrl}/Project/`,
    // GETSHIPINFO_PROJECT: `${apiUrl}/Project/`,
    // EDITSHIPINFO_PROJECT: `${apiUrl}/Project/shipParticular/`,
    // ADDHISTORYINFO_PROJECT: `${apiUrl}/Project/HistoryLog`,

    // Dashboard 
    DASHBOARD_DETAILS: `${apiUrl}/Project/DashBoard/`,

    // // Ship Document
    // SHIP_DOCUMENT: `${apiUrl}/api/ShipDocument/`,

    // // Yard Document 
    // YARD_DOCUMENT: `${apiUrl}/api/YardDocument/`,

    ACTION_YARDROLES: `${apiUrl}/api/YardRole/`,
    ACTION_YARDTRAININGS: `${apiUrl}/api/YardTraining/`,

    // // Yard AuditReport Document
    // YARD_AUDITREPORT: `${apiUrl}/api/YardAuditReport/`,

    // // Corrective Actions
    // CORRECTIVE_ACTIONS: `${apiUrl}/api/CorrectiveActions/`,

    // OPA
    OPA_LISTVIEW: `${apiUrl}/api/OperationPlanning`,
    OPA_EDIT: `${apiUrl}/api/OperationPlanning`,

    // PreBeaching Documents
    PBD_LISTVIEW: `${apiUrl}/api/PreBeaching`,
    LOOKUP_DESCPBD: `${apiUrl}/api/LookUp/Description`,

    // WorkPermits
    WP_LISTVIEW: `${apiUrl}/api/WorkPermit`,

    // Training Module
    TRAINING_MODULE: `${apiUrl}/api/TrainingModule/`,

    // Daily Work Progress Report 
    DWPR_LISTVIEW: `${apiUrl}/api/DailyProgress`,
    LOOKUP_ACTDWPR: `${apiUrl}/api/LookUp/DailyActivities`,

    //Pre Cutting Progress
    PCP_LISTVIEW: `${apiUrl}/api/PreCutting`,
    LOOKUP_ACTIVITY: `${apiUrl}/api/LookUp/PreCuttingActivity`,

    //Daily Man power status
    DMS_LISTVIEW: `${apiUrl}/api/DailyManPower`,

    //HSEQ KPI
    GET_KPI: `${apiUrl}/api/KPI`,
    PUT_KPI: `${apiUrl}/api/KPI/`,

    //HSEQ KPI
    HSEQ_URL: `${apiUrl}/api/HSEQPerformance`,

    //Matrix of Meterial
    MOM_LISTVIEW: `${apiUrl}/api/MatrixOfMaterial`,

    //Reports

    REPORTS_LISTVIEW: `${apiUrl}/api/Report/GetReportList`,
    REPORTS_CHANGESTATUS: `${apiUrl}/api/Report/ChangeRegenerationStaus`,

    // PreCutting Report 

    PRECUTTING_REPORT_DOWN: `${apiUrl}/api/Report/pdf/PreCutting/Download`,
    PRECUTTING_REPORTSHOW: `${apiUrl}/PreCutting`,

    //Montly Report
    MONTHLY_REPORT: `${apiUrl}/api/Report/pdf/Monthly`,
    MONTHLY_REPORTSHOW: `${apiUrl}/Monthly`,
    MONTHLY_REPORT_DOWN: `${apiUrl}/api/Report/pdf/Monthly/Download`,

    //Weekly Report
    WEEKLY_REPORT: `${apiUrl}/api/Report/pdf/Weekly`,
    WEEKLY_REPORTSHOW: `${apiUrl}/Weekly`,
    WEEKLY_REPORT_DOWN: `${apiUrl}/api/Report/pdf/Weekly/Download`,

    //Final Report
    FINAL_REPORTSHOW: `${apiUrl}/Final`,
    FINAL_REPORT_DOWN: `${apiUrl}/api/Report/pdf/Final/Download`,

    PRECUTTING_GETMAIL: `${apiUrl}/api/User/projectId`,
    //State of Completion
    STATEMENTOFCOMPLETION: `${apiUrl}/api/StatementOfCompletion`,


    // Investigation Report
    IR_LISTVIEW: `${apiUrl}/api/InvestigationReport`,

    //Inidial Audit Daily Observation status
    IADOS_LISTVIEW: `${apiUrl}/api/DailyObservation`,

    //Disposition records
    DIS_LISTVIEW: `${apiUrl}/api/Disposition`,

    //Dismantling Progress
    DISMANTLING_PROGRESS: `${apiUrl}/api/DismantlingProgress`,

    //Training Plan
    TRAINING_PLAN: `${apiUrl}/api/Training`,

    //Drill Plan
    DRILL_PLAN: `${apiUrl}/api/DrillPlan`,

    //Dismantling plan - Section division
    BLOCK_DIVISION: `${apiUrl}/api/BlockSection`,
    DRAWING_DIVISION: `${apiUrl}/api/DismantlingPlan/SectionPlan`,

    //Dismantling plan - Block division
    BLOCKPLAN: `${apiUrl}/api/DismantlingPlan/BlockPlan`,

    INITIAL_AUDIT: `${apiUrl}/api/DailyObservation/IntialAudit`,

    WEIGHTCALCULATION: `${apiUrl}/api/DismantlingWeight/`,

    BLOCK: `${apiUrl}/api/`,

    PROJECT_INFO: `${apiUrl}/Project/ProjectInfo`,

    WEEKLY_LIST: `${apiUrl}/api/Report/GetWeekList`,

    MONTHLY_LIST: `${apiUrl}/api/Report/GetMonthList`,

    GET_YARDTRAININGPLAN: `${apiUrl}/api/YardTrainingPlan/`,

    GET_YARDPLANNING: `${apiUrl}/api/YardTrainingPlan/planDate`,

    // Common 

    POST_ATTACHMENTS : `${apiUrl}/api/Master/Attachments?module=`,
    DELETE_ATTACHMENTS : `${apiUrl}/api/Master/Attachments`,

    // Verify Duplicate Names
    verifyDuplicate_Yard: `${apiUrl}/api/Yard/verify/duplicate?yardName=`,
    verifyDuplicate_Roles: `${apiUrl}/api/Master/CommonRoles/verify/duplicate?roleName=`,
    verifyDuplicate_Trainings: `${apiUrl}/api/Master/CommonTrainings/verify/duplicate?trainingName=`,
    verifyDuplicate_AdditionalTrainings: `/additionaltrainings/verify/duplicate?trainingName=`,
    verifyDuplicate_AdditionalRoles: `/additionalroles/verify/duplicate?roleName=`,
    verifyDuplicate_CommonRoles: `/commonroles/verify/duplicate?roleName=`,

    // Carbon Foot Print 
    CFP_MASTERDATA: `${apiUrl}/api/CarbonEmission/MasterData`,
    CFP_MASTERDATA_DAILY_TASK: `${apiUrl}/api/CarbonEmission/EmissionFactor`,
    CFP_MASTERDATA_BY_ID: `${apiUrl}/api/CarbonEmission/MasterDataById`,
    
};

